import React, { useContext, useEffect, useRef, useState } from 'react';
import FinalMolGrid from '../../../../../components/FinalMolGrid/FinalMolGrid';
import Buttons from '../../../../../components/ui/button/Buttons';
import { PricingDetailsData } from '../data/PricingDetails.Data';
import CenterModel from '../../../../../components/ui/centerModel/CenterModel';
import EditPricingDetail from './EditPricingDetail';
import { MembershipType } from '../../../../../utils/Constants';
import BasicDetailContext from '../../../utils/BasicDetailContext';

const pricingPackgae = [{
    id: MembershipType.ASSOCIATE,
    eventPackageId: 0,
    eventPackageName: "Associate",
    eventPrice: 10,
    earlyBird: '0',
    earlyPromotionStartDate: new Date(),
    earlyPromotionendDate: new Date(),
    earlyMaxQuantity: '0',
    superEarlyBird: '0',
    superEarlyPromotionStartDate: new Date(),
    superEarlyPromotionendDate: new Date(),
    superEarlyMaxQuantity: '0',
},
{
    id: MembershipType.FELLOW,
    eventPackageId: 0,
    eventPackageName: "Fellow",
    eventPrice: 20,
    earlyBird: '0',
    earlyPromotionStartDate: new Date(),
    earlyPromotionendDate: new Date(),
    earlyMaxQuantity: '0',
    superEarlyBird: '0',
    superEarlyPromotionStartDate: new Date(),
    superEarlyPromotionendDate: new Date(),
    superEarlyMaxQuantity: '0',
},
{
    id: MembershipType.LIFEFELLOW,
    eventPackageId: 0,
    eventPackageName: "Life Fellow",
    eventPrice: 30,
    earlyBird: '0',
    earlyPromotionStartDate: new Date(),
    earlyPromotionendDate: new Date(),
    earlyMaxQuantity: '0',
    superEarlyBird: '0',
    superEarlyPromotionStartDate: new Date(),
    superEarlyPromotionendDate: new Date(),
    superEarlyMaxQuantity: '0',
},
{
    id: MembershipType.STUDENTASSOCIATE,
    eventPackageId: 0,
    eventPackageName: "Student Associate",
    eventPrice: 40,
    earlyBird: '0',
    earlyPromotionStartDate: new Date(),
    earlyPromotionendDate: new Date(),
    earlyMaxQuantity: '0',
    superEarlyBird: '0',
    superEarlyPromotionStartDate: new Date(),
    superEarlyPromotionendDate: new Date(),
    superEarlyMaxQuantity: '0',
},
{
    id: MembershipType.NONMEMBER,
    eventPackageId: 0,
    eventPackageName: "Non Member",
    eventPrice: 50,
    earlyBird: '0',
    earlyPromotionStartDate: new Date(),
    earlyPromotionendDate: new Date(),
    earlyMaxQuantity: '0',
    superEarlyBird: '0',
    superEarlyPromotionStartDate: new Date(),
    superEarlyPromotionendDate: new Date(),
    superEarlyMaxQuantity: '0',
},]

const PricingDetails = () => {
    const pricingDetailsRef = useRef();
    const [openAddModalPopup, setOpenAddModalPopup] = useState(false); // Modal visibility state
    const [editPricingData, setEditPricingData] = useState({});
    const { pricingPackageDetails, setPricingPackageDetails, alowPricingEdit } = useContext(BasicDetailContext);

    // const [pricingPackageDetails, setPricingPackageDetails] = useState([]);

    useEffect(() => {
        setPricingPackageDetails(pricingPackgae)
    }, [])

    const handleAdd = () => {
        return;
        let temp = [...pricingPackageDetails]
        temp.push({
            id: MembershipType.OTHER,
            eventPackageId: 0,
            eventPackageName: "Other",
            eventPrice: 50,
            earlyBird: '0',
            earlyPromotionStartDate: new Date(),
            earlyPromotionendDate: new Date(),
            earlyMaxQuantity: '0',
            superEarlyBird: '0',
            superEarlyPromotionStartDate: new Date(),
            superEarlyPromotionendDate: new Date(),
            superEarlyMaxQuantity: '0',
        })
        setPricingPackageDetails(temp)
    }

    const handleEditClick = (data, rowIndex) => {
        if (!alowPricingEdit) return;
        setEditPricingData({ ...data });
        setOpenAddModalPopup(true);
    };

    const handleDeleteClick = (data) => {
        console.log("Handle DELETE Click");
    };

    const actionHandler = {
        EDIT: handleEditClick,
        DELETE: handleDeleteClick
    };

    /* Add Member Modal Toggle */
    const handleEditPricingDetails = (formData) => {
        const { id, rowIndex } = formData;
        let updatedPricingDtails = pricingPackageDetails.map((obj, index) => {
            return obj.id === id ? { ...formData } : obj;
        })
        setPricingPackageDetails(updatedPricingDtails);
        handleClosePricingModel();
    };

    const handleClosePricingModel = () => {
        setOpenAddModalPopup(!openAddModalPopup);
    }

    return (
        <div>
            <FinalMolGrid
                ref={pricingDetailsRef}
                dataSource={pricingPackageDetails}
                configuration={PricingDetailsData}
                onRowDataUpdate={handleEditClick}
                onActionChange={actionHandler}
            />
            <div className="multi-btn-sec justify-content-between mt-1">
            </div>
            {openAddModalPopup && (
                <CenterModel
                    modelTitle="Edit Lesson"
                    show
                    // isLoading={isAddMemberLoading}
                    // isDisable={isAddMemberLoading}
                    handleClose={handleClosePricingModel}
                >
                    <EditPricingDetail editPricingData={editPricingData} handleEditPricingDetails={handleEditPricingDetails} />
                </CenterModel>
            )}
        </div>
    );
};

export default PricingDetails;
